export const LEDGER_TYPES = {
  DEPRECIATION: "DEPRECIATION",
  AMORTIZATION: "AMORTIZATION",
  PREPAID_EXPENSES: "PREPAID_EXPENSES",
  DEFERRED_REVENUE: "DEFERRED_REVENUE",
  ACCRUED_REVENUE: "ACCRUED_REVENUE",
  PAYMENT_PROCESSOR: "PAYMENT_PROCESSOR",
  OTHERS: "OTHERS",
  PAYROLL: "PAYROLL",
  ACCOUNTS_RECEIVABLE: "ACCOUNTS_RECEIVABLE",
  ACCOUNTS_PAYABLE: "ACCOUNTS_PAYABLE",
  REVENUE_RECOGNITION: "REVENUE_RECOGNITION",
  EXPENSE_RECOGNITION: "EXPENSE_RECOGNITION",
  ACCRUED_EXPENSE: "ACCRUED_EXPENSE",
} as const;

export type LedgerTypeKeys = keyof typeof LEDGER_TYPES;
export type LedgerTypeValues = (typeof LEDGER_TYPES)[LedgerTypeKeys];

export const LEDGER_TYPE_OPTIONS = [
  { label: "Accounts Receivable", value: LEDGER_TYPES.ACCOUNTS_RECEIVABLE },
  { label: "Accounts Payable", value: LEDGER_TYPES.ACCOUNTS_PAYABLE },
  { label: "Payment Processor", value: LEDGER_TYPES.PAYMENT_PROCESSOR },
  { label: "Revenue Recognition", value: LEDGER_TYPES.REVENUE_RECOGNITION },
  { label: "Expense Recognition", value: LEDGER_TYPES.EXPENSE_RECOGNITION },
  { label: "Payroll", value: LEDGER_TYPES.PAYROLL },
  { label: "Depreciation", value: LEDGER_TYPES.DEPRECIATION },
  { label: "Amortization", value: LEDGER_TYPES.AMORTIZATION },
  { label: "Prepaid Expenses", value: LEDGER_TYPES.PREPAID_EXPENSES },
  { label: "Accrued Revenue", value: LEDGER_TYPES.ACCRUED_REVENUE },
  { label: "Accrued Expense", value: LEDGER_TYPES.ACCRUED_EXPENSE },
  { label: "Others", value: LEDGER_TYPES.OTHERS },
];
